document.addEventListener("DOMContentLoaded", function() {
    // كائن يحتوي على أسماء الفيندورات مع روابط الشعارات الخاصة بهم
    const vendorLogos = {
        "Apple": "https://cdn.shopify.com/s/files/1/0026/9906/7504/files/Sony_logoadad.png?v=1742805041",
        "Sony": "https://cdn.shopify.com/s/files/1/0026/9906/7504/files/Sony_logo.png?v=1742802980",
        "Samsung": "https://cdn.shopify.com/s/files/1/0026/9906/7504/files/Sony_logos.png?v=1742803831",
        "Gamax": "https://cdn.shopify.com/s/files/1/0026/9906/7504/files/Sony_logodasas.png?v=1742805360",
        "UGreen": "https://cdn.shopify.com/s/files/1/0026/9906/7504/files/Sony_logodaaa.png?v=1742805679",
        "GravaStar": "https://cdn.shopify.com/s/files/1/0026/9906/7504/files/Sony_logosa.png?v=1742805848",
        "Sades": "https://cdn.shopify.com/s/files/1/0026/9906/7504/files/Sony_logoas.png?v=1742806010",
        "Arozzi": "https://cdn.shopify.com/s/files/1/0026/9906/7504/files/Sony_logosasa.png?v=1742806108"
    };

    // البحث عن العنصر الذي يحتوي على اسم الفيندور
    const vendorElement = document.querySelector(".product-vendor a");
    
    if (vendorElement) {
        const vendorName = vendorElement.textContent.trim(); // استخراج النص
        
        // التحقق مما إذا كان الفيندور في القائمة
        if (vendorLogos[vendorName]) {
            // إنشاء عنصر صورة جديدة
            const logoImg = document.createElement("img");
            logoImg.src = vendorLogos[vendorName];
            logoImg.alt = vendorName + " Logo";
            logoImg.style.width = "100px"; // تحديد العرض بـ 40 بكسل
            logoImg.style.height = "auto"; // الحفاظ على التناسب
            logoImg.style.paddingTop = "0px"; // إضافة بادنج توب بـ 6 بكسل
            logoImg.style.marginBottom = "4px";
            // استبدال النص بالصورة
            vendorElement.innerHTML = "";
            vendorElement.appendChild(logoImg);
        }
    }
});













document.addEventListener("DOMContentLoaded", function() {
    const thumbsContainer = document.querySelector(".media-gallery__thumbs ul");

    if (thumbsContainer) {
        // ضبط CSS للسلايدر العمودي
        thumbsContainer.style.display = "flex";
        thumbsContainer.style.flexDirection = "column";
        thumbsContainer.style.overflowY = "auto";
        thumbsContainer.style.overflowX = "hidden";
        thumbsContainer.style.maxHeight = "500px"; // تحديد ارتفاع معين
        thumbsContainer.style.scrollBehavior = "smooth";

        // إنشاء أزرار التنقل (أعلى وأسفل)
        const prevBtn = document.createElement("button");
        const nextBtn = document.createElement("button");

        prevBtn.innerHTML = "&#9650;"; // سهم للأعلى
        nextBtn.innerHTML = "&#9660;"; // سهم للأسفل

        prevBtn.classList.add("thumbs-nav-btn", "thumbs-prev");
        nextBtn.classList.add("thumbs-nav-btn", "thumbs-next");

        // وضع الأزرار في DOM
        const parentDiv = document.querySelector(".media-gallery__thumbs");
        if (parentDiv) {
            parentDiv.appendChild(prevBtn);
            parentDiv.appendChild(nextBtn);
        }

        // التحكم في التمرير عند الضغط على الأزرار
        prevBtn.addEventListener("click", () => {
            thumbsContainer.scrollBy({ top: -100, behavior: "smooth" });
        });

        nextBtn.addEventListener("click", () => {
            thumbsContainer.scrollBy({ top: 100, behavior: "smooth" });
        });

        // إظهار/إخفاء الأزرار بناءً على التمرير
        function updateButtonsVisibility() {
            prevBtn.style.display = thumbsContainer.scrollTop > 0 ? "block" : "none";
            nextBtn.style.display = thumbsContainer.scrollTop < (thumbsContainer.scrollHeight - thumbsContainer.clientHeight) ? "block" : "none";
        }

        thumbsContainer.addEventListener("scroll", updateButtonsVisibility);
        updateButtonsVisibility(); // تحديث الحالة عند تحميل الصفحة لأول مرة
    }
});




// حدد العنصر الذي يحتوي على أيقونات الدفع
let paymentIconsContainer = document.querySelector('.footer__payment .payment-icons');

// قم بإنشاء عنصر الصورة
let imgElement = document.createElement('img');
imgElement.src = 'https://cdn.shopify.com/s/files/1/0026/9906/7504/files/Sony_logoq1.png?v=1742890164';
imgElement.alt = 'Sony Logo';

// تعديل عرض الصورة إلى 300 بكسل
imgElement.style.width = '160px';

// امسح محتويات العنصر الحالي وأضف الصورة بدلاً منها
paymentIconsContainer.innerHTML = '';
paymentIconsContainer.appendChild(imgElement);












var paymentIcons = document.querySelector('.payment-icons');

if (paymentIcons) {
  paymentIcons.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0026/9906/7504/files/Sony_logoq1234.png?v=1742890569" width="160" alt="Sony Logo" style="margin-top: 20px; margin-bottom: 20px;">';
}






document.addEventListener("DOMContentLoaded", function() {
  // دالة لتطبيق التعديلات على كل بادج
  function applyLabelEnhancements() {
    const productLabels = document.querySelectorAll('.product-label--sale');

    if (productLabels.length === 0) return;

    productLabels.forEach(function(productLabel) {
      const fireIconUrl = "https://cdn.shopify.com/s/files/1/0026/9906/7504/files/360_F_338928104_6b4Nhr5PxIIVc1RxB8zCP9YWw8kgqnEm.png?v=1743094008";

      if (!productLabel.classList.contains('modified')) {
        // الحصول على النص الأصلي داخل البادج
        let labelText = productLabel.textContent.trim();

        // التحقق من اللغة — لو عربي، نغير "off" إلى "خصم"
        const isArabic = document.documentElement.lang === 'ar' || document.title.includes('ع');

        if (isArabic) {
          labelText = labelText.replace(/off/i, 'خصم');
        }

        // استبدال المحتوى بالأيقونة والنص
        productLabel.innerHTML = `<img src="${fireIconUrl}" alt="Fire Icon" class="fire-icon" /> ${labelText}`;

        // تنسيق البادج
        productLabel.style.display = 'inline-flex';
        productLabel.style.alignItems = 'center';
        productLabel.style.backgroundColor = '#e0091f';
        productLabel.style.color = 'white';
        productLabel.style.padding = '4px 8px';
        productLabel.style.fontSize = '10px';
        productLabel.style.fontWeight = 'bold';
        productLabel.style.borderRadius = '20px';
        productLabel.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
        productLabel.style.gap = '2px';
        productLabel.style.transition = 'background 0.3s ease, transform 0.3s ease';

        // تصغير الأيقونة
        const fireIcon = productLabel.querySelector('.fire-icon');
        if (fireIcon) {
          fireIcon.style.width = '18px';
          fireIcon.style.height = '18px';
          fireIcon.style.marginRight = '2px';
        }

        // تأثير hover
        productLabel.addEventListener('mouseover', function() {
          productLabel.style.backgroundColor = '#d5071a';
          productLabel.style.transform = 'scale(1.1)';
        });

        productLabel.addEventListener('mouseout', function() {
          productLabel.style.backgroundColor = '#e0091f';
          productLabel.style.transform = 'scale(1)';
        });

        // منع التكرار
        productLabel.classList.add('modified');
      }
    });
  }

  // مراقبة التغييرات في الصفحة
  const observer = new MutationObserver(function(mutationsList) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        applyLabelEnhancements();
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  applyLabelEnhancements();
});









